export var NotificationServiceEvent;
(function (NotificationServiceEvent) {
    NotificationServiceEvent["NotificationReceived"] = "NotificationReceived";
})(NotificationServiceEvent || (NotificationServiceEvent = {}));
